export default __webpack_public_path__ + "static/media/light.1e81d9d1.png";